<template>
    <div class="context common_add_view">
        <div class="header">
            <div class="search">
                <el-page-header @back="back" :content="viewTitle">
                </el-page-header>
            </div>
        </div>
        <div class="main_box">
            <el-form :model="form" :rules="rules" ref="form" label-width="150px">
                <el-form-item label="产品名称：">
                    <span>{{form.product_name}}</span>
                </el-form-item>
                <el-form-item label="产品代码：">
                    <span>{{form.product_code}}</span>
                </el-form-item>
                <el-form-item label="产品ID：">
                    <span>{{form.drug_code}}</span>
                </el-form-item>
                <el-form-item label="周期天数：" prop="cycle_days">
                    <el-input-number v-model="form.cycle_days"
                                     controls-position="right"
                                     :min="1" :max="100"></el-input-number>
                </el-form-item>
                <el-form-item label="计算周期方式：" prop="cycle_type">
                    <el-radio-group v-model="form.cycle_type" @input="changeCycleType">
                        <el-radio label="count">按支数</el-radio>
                        <el-radio label="time">按次数</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item v-if="form.cycle_type === 'count'"
                              label="周期用药支数："
                              prop="cycle_medication_count">
                    <el-input-number v-model="form.cycle_medication_count"
                                     controls-position="right"
                                     :min="1" :max="100"></el-input-number>
                </el-form-item>
                <el-form-item label="类别：" prop="drug_type_list">
                    <el-checkbox-group v-model="form.drug_type_list">
                        <el-checkbox v-for="(item, index) in typeAll"
                                     :key="index"
                                     :label="item"></el-checkbox>
                    </el-checkbox-group>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitNow">提交</el-button>
                </el-form-item>
            </el-form>

        </div>
    </div>
</template>

<script>
    import {mapState, mapMutations} from "vuex"
    import {clone} from "@/global/utils";

    export default {
        name: "editView",
        data() {
            return {
                viewTitle: '修改产品配置',

                form: {
                    cycle_type: 'count',
                    cycle_days: 21,
                    cycle_medication_count: 1,
                    drug_type_list: []
                },
                rules: {
                    cycle_days: [{required: true, message: '请输入周期天数', type: 'number', target: 'blur'}],
                    cycle_medication_count: [{required: true, message: '请输入周期用药支数',type: 'number', target: 'blur'}],
                },
                typeAll: ['医保','自费','商保','赠药','赠药+商保']
            }
        },
        computed: {
            ...mapState('manageData', {
                drug_config_data: 'drug_config_data'
            }),
        },
        mounted() {
            console.log(this.drug_config_data, '20');
            if (this.drug_config_data) {
                this.form = clone(this.drug_config_data);
                this.form.drug_type_list = this.form.drug_type_list ? this.form.drug_type_list : [];
                this.form.cycle_type = this.form.cycle_type ? this.form.cycle_type : 'count'
            }
        },
        methods: {
            back() {
                this.$emit('changeTopTab', 'tableView')
            },
            changeCycleType(e) {
                // console.log(e , this.form, '93');
                this.$forceUpdate()
            },

            submitNow() {
                this.$refs.form.validate(valid => {
                    if (valid) {
                        let params = {
                            ...this.form
                        };
                        this.httpPut(`/product/${params.pid}`, params).then(res => {
                            this.$message.success('修改成功！');
                            this.back()
                        })
                    }
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>